export default __webpack_public_path__ + "static/media/6.65a621e4.png";